import React, { useCallback } from 'react';
import { useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import RiskDefault from './Switch/Risk/RiskDefault';
import ControlDefault from './Switch/Control/ControlDefault';
import ActionPlanDefault from './Switch/ActionPlan/ActionPlanDefault';

export default function ElementContainer({ view, elementID }) {
  const { moduleBridgeHex } = useParams();
  const permissionsLevel = useSelector(
    (s) => s.module[moduleBridgeHex]?.userBridge?.permissions?.level
  );

  const Switch = useCallback(() => {
    switch (view) {
      default:
      case 'list':
        return <RiskDefault elementID={elementID} />;
      case 'control':
        return <ControlDefault elementID={elementID} />;
      case 'actionPlan':
        return <ActionPlanDefault elementID={elementID} />;
    }
  }, [elementID, view, permissionsLevel]);

  return (
    <div className="pt-2">
      <Switch />
    </div>
  );
}
